
import React from 'react';
import { Property, AppUser, UserRole } from '../../../types';
import { UserCircleIcon, DevicePhoneMobileIcon, EnvelopeIcon } from '../../Icons';

export const PropertyOwnerSection: React.FC<{ property: Property; appUser: AppUser | null }> = ({ property, appUser }) => {
  const isFullAccess = appUser && [
    UserRole.COMERCIAL_INTERNO,
    UserRole.BROKER_INTERNO,
    UserRole.ADMIN, 
    UserRole.SUPERADMIN,
    UserRole.OPERACION
  ].includes(appUser.role);

  const isNameOnly = appUser && [
    UserRole.BROKER,
    UserRole.BROKER_PREMIUM
  ].includes(appUser.role);

  if (!isFullAccess && !isNameOnly) return null;

  return (
    <section className="animate-fade-in">
      <div className="flex items-center mb-4">
        <UserCircleIcon className="w-5 h-5 mr-2 text-sky-700" />
        <h3 className="text-lg font-black uppercase tracking-tighter text-[#00234F]">Datos del Propietario</h3>
      </div>
      <div className="bg-sky-50/40 border border-sky-100 rounded-[2.5rem] p-8 sm:p-10 text-center space-y-8 shadow-sm">
        <div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.25em] mb-2">Dueño</p>
          <p className="text-2xl font-black text-sky-900 uppercase tracking-tight">{property.owner?.replace(/_/g, ' ') || 'No especificado'}</p>
        </div>
        
        {isFullAccess && (
          <>
            {property.telefono_cliente && (
              <div>
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.25em] mb-3">Celular de Contacto</p>
                <div className="flex items-center justify-center gap-3 text-sky-600 font-black">
                  <DevicePhoneMobileIcon className="w-6 h-6" />
                  <span className="text-2xl tracking-tighter">{property.telefono_cliente}</span>
                </div>
              </div>
            )}
            {property.correo_1 && (
              <div>
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-[0.25em] mb-2">Correo Contacto</p>
                <div className="flex items-center justify-center gap-2 text-sky-700 font-bold text-sm lowercase">
                  <EnvelopeIcon className="w-4 h-4" />
                  <span>{property.correo_1}</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};
